/* eslint-disable max-statements */
import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from 'src/Components/Button_V2';
import styles from './styles.module.scss';
import icArrowDown from 'assets/svg/ic_arrow_down_fill.svg';

const NotFoundPage = () => {
  const history = useHistory();

  const handleClick = () => {
    history.goBack();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title,
    "data-text": "404"
  }, "404"), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.pageNotFoundText
  }, "Page not found"), /*#__PURE__*/React.createElement("span", {
    className: styles.errorText
  }, "The page you're looking for does not seem to exist")), /*#__PURE__*/React.createElement(Button, {
    title: "Go back",
    type: "primary",
    className: styles.backHomePageButton,
    icon: icArrowDown,
    onClick: handleClick
  }));
};

export default NotFoundPage;